module.exports = __webpack_public_path__ + "files/98d2a46dbab13a2a3b0a4cc4f0183b11.png";